import { render, staticRenderFns } from "./PersnoaApplicationDetail.vue?vue&type=template&id=23c006c9&scoped=true&"
import script from "./PersnoaApplicationDetail.vue?vue&type=script&lang=js&"
export * from "./PersnoaApplicationDetail.vue?vue&type=script&lang=js&"
import style0 from "./PersnoaApplicationDetail.vue?vue&type=style&index=0&id=23c006c9&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23c006c9",
  null
  
)

export default component.exports